import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

const swiper = new Swiper(".js-reasonSwiper", {
  autoplay: {
    delay: 4000,
    disableOnInteraction: false,
  },
  breakpoints: {
    768: {
      centeredSlides: true,
    },
  },
  centeredSlides: false,
  loop: true,
  navigation: {
    nextEl: ".js-reasonSwiperButtonNext",
    prevEl: ".js-reasonSwiperButtonPrev",
  },
  pagination: {
    clickable: true,
    el: ".js-reasonSwiper .swiper-pagination",
  },
  slidesPerView: "auto",
  spaceBetween: 0,
});
